export function upperSnakeToKebab(value: string): string {
    return value.toLowerCase().replace(/_/g, '-');
}
